import React from 'react';

function Profile({ user }) {
  if (!user) {
    return (
      <div className="auth-required">
        <p>Please sign in to view your profile</p>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <div className="content-inner">
        <div className="card-container">
          <h2 className="section-title mb-2">User Profile</h2>
          <p className="subtitle">Your account information</p>

          <div className="profile-details">
            {/* Profile Picture */}
            {user.picture && (
              <div className="profile-picture-container">
                <img
                  src={user.picture}
                  alt={user.name}
                  className="profile-picture"
                />
              </div>
            )}

            {/* User Details */}
            <div className="profile-fields">
              <div>
                <label className="profile-field-label">
                  Full Name
                </label>
                <p className="profile-field-value">
                  {user.name}
                </p>
              </div>

              <div>
                <label className="profile-field-label">
                  Email Address
                </label>
                <p className="profile-field-value">
                  {user.email}
                </p>
              </div>

              {user.email_verified && (
                <div>
                  <label className="profile-field-label">
                    Verification Status
                  </label>
                  <p className="profile-field-value verified">
                    ✓ Email Verified
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
